<div class="card">
    <div class="card-body">
      
      <div class="d-flex mb-3">
        <h4 class="card-title">Videos</h4>
        <button type="button" class="btn btn-primary ms-auto" (click)="addNewModal()">
          Add New
        </button>
      </div>

      <section class="video-library-form py-3 bg-white position-relative mb-4">
        <div class="">
          <div class="row video-library-form g-3">
            <div class="col-md-6 col-lg-3" >
              <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" class="selectpicker rules font-oswald w-100"
                (change)="allLevelsOfRule()" [(ngModel)]="rules">
                <option value="">Select Rule</option>
                <option *ngFor="let rule of rulesList" [value]="rule?.id">{{rule?.name}}</option>
              </select>
            </div>
            <div class="col-md-6 col-lg-3" >
              <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" class="selectpicker level font-oswald w-100"
                [(ngModel)]="levels" [disabled]="disableLevel" (change)="allCategories()">
                <option value="">Select Level</option>
                <option *ngFor="let level of levelsList" [value]="level?.id">{{level?.name | titlecase}}</option>
              </select>
            </div>
            <div class="col-md-6 col-lg-3" >
              <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300"
                class="selectpicker category font-oswald w-100" [(ngModel)]="category" [disabled]="disableCategory"
                (change)="allSkills()">
                <option value="">Select Category</option>
                <option *ngFor="let cat of categoryList" [value]="cat?.id">{{cat?.name | titlecase}}</option>
              </select>
      
            </div>
            <div class="col-md-6 col-lg-3" >
              <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" title="Select Skills" multiple class="selectpicker skill font-oswald w-100"
                [(ngModel)]="skill" [disabled]="disableSkills">
                <option *ngFor="let skill of skillsList" [value]="skill?.id">{{skill?.name | titlecase}}</option>
              </select>
            </div>
          </div>
        </div>
        <!-- <hr class="mt-2 mb-1" *ngIf="attributeList"> -->
      
        <div class="" *ngIf="attributeList">
          <div class="d-flex  flex-wrap search-attributes-div mt-3">  
            <div class="flex-fill mb-2" *ngFor="let item of attributeList">
              <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300"
                class="selectpicker attributes font-oswald w-100" [title]="toLower(item.name)" (change)="getAttributesVal($event,item.id)"
                [(ngModel)]="attri[item.name]">
                <option *ngFor="let choice of item.choices" [value]="choice.choice_id">{{choice.title}}</option>
              </select>
            </div>
          </div>
        </div>
        <!-- <hr class="mt-2 mb-1" *ngIf="attributeList"> -->
        <div class="">
          <div class="video-library-form g-3">
            <button class="btn btn-sm btn-primary" type="submit" (click)="search()">Search</button>
              <button class="btn btn-sm btn-info ms-4" (click)="resetSearch()" type="submit">Reset</button>
          </div>
        </div>
      </section>
	
      <ng-template #basicActions let-data="adtData" let-emitter="captureEvents">
        <app-basic-actions [data]="data" (emitter)="emitter($event)"></app-basic-actions>
      </ng-template>

      <app-admin-new-video [modalid]="modalid" [video]="editVideo" (newItemEvent)="changeData($event)"></app-admin-new-video>
      <app-admin-common-delete [modalid]="modalid1" table="videos" [id]="deleteid" (newItemEvent)="changeData($event)"></app-admin-common-delete>
      <!-- <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover"></table> -->
      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table"></table>
    </div>
</div>